import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
`;
